import React from "react";
import { useSelector } from "react-redux";

import { Facets } from "components";
import { i18nService } from "services";
import {
  ActiveToolFacetType,
  IToolFacet,
  IActiveFacet,
  IAPIState,
} from "types";

import { makeSchema } from "../data/formSchema";
import { toolSearchMetaSelector } from "../state";

interface ToolSearchFacetsContainerProps {
  facets: IToolFacet[];
  setQueryTerm: (term: string) => void;
  setQueryFacets: (activeFacet: ActiveToolFacetType) => void;
  defaultValues?: Record<string, any>;
  activeFacets?: IActiveFacet[];
  clearAllFacets: () => void;
}

export const ToolSearchFacetsContainer: React.FC<ToolSearchFacetsContainerProps> = ({
  facets,
  setQueryTerm,
  setQueryFacets,
  defaultValues,
  activeFacets,
  clearAllFacets,
}) => {
  const { status, pagination } = useSelector(toolSearchMetaSelector);

  return (
    <div className="tool-search__sidebar">
      <Facets
        {...makeSchema(facets, setQueryTerm, setQueryFacets)}
        defaultValues={defaultValues}
        activeFacets={activeFacets}
        clearAllFacets={clearAllFacets}
        mobileTitle={i18nService.copy["toolSearch.filterTitle"]}
        nbResults={pagination?.total}
        isLoading={status === IAPIState.pending}
      />
    </div>
  );
};
